interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) {
    pages.push(i);
  }

  return (
    <nav className="mt-8 flex items-center justify-center gap-2 flex-wrap" aria-label="分页">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="inline-flex items-center gap-1 px-3 py-2 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-9 h-9 rounded-md text-sm font-medium cursor-pointer transition-colors ${
            p === current
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-600'
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="inline-flex items-center gap-1 px-3 py-2 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}